import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const ContainerSidebar = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
`;

interface IIcon {
  width: number;
}

export const Block = styled.div<IIcon>`
  background: #fff;
  border-radius: 0 0 8px 8px;
  border: 1px solid #d8dae5;
  border-top: transparent;
  position: absolute;
  top: 42px;
  width: 216px;
  z-index: 10;
  cursor: auto;
`;

export const CircleDiv = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  color: ${beam.color.pureWhite};
  background: ${beam.color.primaryBlue};

  border-radius: 50%;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  font-size: 10px;
  font-weight: 700;
  right: -5px;
  bottom: -5px;
  width: 14px;
  height: 14px;
`;

export const Icon = styled.div<IIcon>`
  min-width: ${({ width }) => width}px;
  width: ${({ width }) => width}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MenuIcon = styled.img`
  margin-left: 24px;
  cursor: pointer;
`;

interface IMenuText {
  isPlaceholder: boolean;
}

export const MenuText = styled.div<IMenuText>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ isPlaceholder }) => (isPlaceholder ? '#8f95b2' : '#474d66')};
`;

interface IFakeInputDiv {
  open: boolean;
}

export const FakeInputDiv = styled.div<IFakeInputDiv>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 216px;
  max-width: 216px;
  height: 42px;
  max-height: 42px;
  border: 1px solid #d8dae5;
  border-radius: ${({ open }) => (open ? '8px 8px 0 0' : '8px')};
  padding: 10px 12px 10px 16px;
`;

export const IconDiv = styled.div`
  margin-top: 5px;
`;
